import { render } from "./Collections.vue?vue&type=template&id=37897f15&scoped=true"
import script from "./Collections.vue?vue&type=script&lang=js"
export * from "./Collections.vue?vue&type=script&lang=js"

import "./Collections.vue?vue&type=style&index=0&id=37897f15&scoped=true&lang=css"
import "./Collections.vue?vue&type=style&index=1&id=37897f15&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37897f15"]])

export default __exports__